import React, { useState } from 'react';
import { Mail, Key, Check, X, Loader2 } from 'lucide-react';
import WaitingScreen from "./WaitingScreen";

const ForgotPassword = ({ onBack, redirectUrl }) => {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  // Email validation
  const validateEmail = (emailValue) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue);
  };

  // Step 1: Email Submission
  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateEmail(email)) {
      setError('Please enter a valid email address');
      return;
    }

    setIsLoading(true);
    setError('');

    
    try {
      const response = await fetch('/auth/rest-pwd', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, redirectUrl }),
      });

      const data = await response.json();
      //console.log(data);

      if (response.ok) {        
        setError('')
        setStep(2);
      } else {
        // If the account does not exist, alert the user and stay on email step
        setError(data.error || "Failed to send verification code.");
        setTimeout(() => {
          setError("");
        }, 5000);
      }
      
    } catch (err) {
      setError('Failed to send verification code. Please try again.');
      setTimeout(() => {
        setError('')
    }, 5000);
    } finally {
      setIsLoading(false);
    }
};

  
  return (
    <div className="max-w-md mx-auto bg-gray-800 p-8 rounded-xl space-y-6">
      <h2 className="text-3xl font-light text-white text-center">
        {step === 1 ? 'Forgot Password' : ''}
      </h2>

      {step === 1 && (
        <form onSubmit={handleEmailSubmit} className="space-y-4">
          <div className="relative">
            <Mail className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email address"
              className={`
                w-full p-3 pl-10 rounded-lg 
                bg-gray-700 text-white
                border ${error ? 'border-red-500' : 'border-gray-600'}
                focus:outline-none focus:ring-2 
                ${error ? 'focus:ring-red-500' : 'focus:ring-blue-500'}
              `}
              required
            />
          </div>

          {error && (
            <p className="text-red-400 text-sm text-center">
              {error}
            </p>
          )}

          <button
            type="submit"
            disabled={!validateEmail(email) || isLoading}
            className={`
              w-full py-3 rounded-xl transition-all
              ${validateEmail(email) && !isLoading 
                ? 'bg-blue-600 hover:bg-blue-700 text-white' 
                : 'bg-gray-700 text-gray-400 cursor-not-allowed'}
              flex items-center justify-center space-x-2
            `}
          >
            {isLoading ? (
              <Loader2 className="w-6 h-6 animate-spin" />
            ) : (
              'Send Verification Code'
            )}
          </button>
        </form>
      )}

      {step === 2 && (       
          <WaitingScreen redirectUrl={redirectUrl} />
      )}
    </div>
  );
};

export default ForgotPassword;